(() => {
  if (window.BpHomeLiveCarousel) {
    window.BpHomeLiveCarousel.initialize(document);
    return;
  }

  const instances = new WeakMap();
  const rootSelector = '.bp-home-live[data-bp-live-carousel]';

  function findRoots(scope) {
    const roots = Array.from(scope.querySelectorAll?.(rootSelector) || []);
    if (scope.matches?.(rootSelector)) roots.unshift(scope);
    return roots;
  }

  function initialize(scope) {
    findRoots(scope).forEach((root) => {
      if (instances.has(root)) return;
      const stage = root.querySelector('[data-bp-live-stage]');
      const cards = Array.from(root.querySelectorAll('[data-bp-live-format]'));
      const controls = Array.from(root.querySelectorAll('[data-bp-live-select]'));
      if (!stage || cards.length !== 2 || controls.length !== 2 || !window.ResizeObserver) return;

      const aborter = new AbortController();
      const signal = aborter.signal;
      let active = 'affari';
      let frame = 0;
      let touch = null;

      const setHeight = () => {
        frame = 0;
        if (!root.isConnected || root.getClientRects().length === 0) return;
        const card = cards.find((item) => item.dataset.bpLiveFormat === active);
        if (!card) return;
        const height = Math.ceil(card.offsetHeight);
        if (height > 0) stage.style.setProperty('--bp-live-stage-height', `${height}px`);
      };

      const scheduleHeight = () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(setHeight);
      };

      const choose = (format, focusControl = false) => {
        if (format !== 'affari' && format !== 'box') return;
        active = format;
        root.dataset.bpLiveActive = active;
        cards.forEach((card) => {
          const inactive = card.dataset.bpLiveFormat !== active;
          card.dataset.bpLiveState = inactive ? 'inactive' : 'active';
          card.toggleAttribute('inert', inactive);
          card.setAttribute('aria-hidden', String(inactive));
        });
        controls.forEach((button) => {
          const selected = button.dataset.bpLiveSelect === active;
          button.setAttribute('aria-pressed', String(selected));
          if (selected && focusControl) button.focus({ preventScroll: true });
        });
        scheduleHeight();
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest?.('[data-bp-live-select]');
        if (button && root.contains(button)) choose(button.dataset.bpLiveSelect);
      }, { signal });

      root.addEventListener('keydown', (event) => {
        const button = event.target.closest?.('[data-bp-live-select]');
        if (!button || !root.contains(button)) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          choose(event.key === 'ArrowLeft' ? 'affari' : 'box', true);
        }
      }, { signal });

      stage.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) {
          touch = null;
          return;
        }
        touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true, signal });

      stage.addEventListener('touchend', (event) => {
        if (!touch || event.changedTouches.length !== 1) return;
        const dx = event.changedTouches[0].clientX - touch.x;
        const dy = event.changedTouches[0].clientY - touch.y;
        touch = null;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        if (dx < 0 && active === 'affari') choose('box');
        if (dx > 0 && active === 'box') choose('affari');
      }, { passive: true, signal });

      stage.addEventListener('touchcancel', () => { touch = null; }, { passive: true, signal });
      window.addEventListener('resize', scheduleHeight, { passive: true, signal });
      window.addEventListener('bp:universe-state-change', scheduleHeight, { signal });
      root.querySelectorAll('.bp-home-live__artwork img').forEach((image) => {
        image.addEventListener('load', scheduleHeight, { signal });
      });

      const observer = new ResizeObserver(scheduleHeight);
      cards.forEach((card) => observer.observe(card));
      root.classList.add('is-carousel-ready');
      choose('affari');
      instances.set(root, () => {
        aborter.abort();
        observer.disconnect();
        if (frame) cancelAnimationFrame(frame);
        root.classList.remove('is-carousel-ready');
        root.removeAttribute('data-bp-live-active');
        stage.style.removeProperty('--bp-live-stage-height');
        cards.forEach((card) => {
          card.removeAttribute('inert');
          card.removeAttribute('aria-hidden');
        });
      });
    });
  }

  function unload(scope) {
    findRoots(scope).forEach((root) => {
      instances.get(root)?.();
      instances.delete(root);
    });
  }

  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.BpHomeLiveCarousel = { initialize, unload };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
